import { defineStore } from 'pinia';
import { ref } from 'vue';
import { gql } from '@apollo/client/core';
import { apolloClient } from '@/plugins/nhost';

export const STORE_NAME = 'dataroomModuleConfig';

export interface DataroomModuleMetadata {
  [key: string]: any;
}

const GET_DATAROOM_MODULE_CONFIG = gql`
  query getDataroomModuleConfig($clientId: uuid!) {
    general_module_configuration_dataroom(where: { client_id: { _eq: $clientId } }, limit: 1) {
      metadata
    }
  }
`;

export const useDataroomModuleConfigStore = defineStore(STORE_NAME, () => {
  const clientId = ref<string | null>(null);
  const metadata = ref<DataroomModuleMetadata | null>(null);
  const loaded = ref(false);

  async function fetchConfig(id: string) {
    console.log('[TECH-2681] dataroomModuleConfig.fetchConfig called', { id, loaded: loaded.value, cachedClientId: clientId.value });
    if (!id) return;
    if (loaded.value && clientId.value === id) return;

    try {
      const { data } = await apolloClient.query({
        query: GET_DATAROOM_MODULE_CONFIG,
        variables: { clientId: id },
        fetchPolicy: 'network-only',
      });

      metadata.value = data?.general_module_configuration_dataroom?.[0]?.metadata || null;
      clientId.value = id;
      loaded.value = true;
    } catch (error) {
      console.error('[dataroomModuleConfig] Error fetching module configuration:', error);
    }
  }

  // Investor visibility flags are opt-in (TECH-2680): a section only shows up when the
  // client turned it on. A missing key, or no dataroom config row at all, means hidden —
  // otherwise turning a module on in the cockpit would expose it in the dataroom too.
  function isModuleEnabled(key: string) {
    return !!metadata.value?.[key];
  }

  return {
    clientId,
    metadata,
    loaded,
    fetchConfig,
    isModuleEnabled,
  };
});
